import {
    ChangeDetectionStrategy,
    Component,
    ViewEncapsulation,
    Input,
    Output,
    EventEmitter,
    inject,
} from '@angular/core';
import { ObjectTypes } from '@fi-app/shared/types/object-type';
import { getObjectTypeNameTextId } from '@fi-shared/utils/object-type-name';
import { FiOnboardingElementDropListHelperService } from '../../fi-onboarding-element-drop-list-helper.service';
import {
    IOnboardingElementParameter,
    IAvailableOnboardingStepElement,
} from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.d';
import { FiRemoteStateFullDataSource } from '@fi-app/shared/fi-items-list/fi-remote-state-full-data-source';
import { FiItemsListType } from '@fi-app/shared/fi-items-list/fi-items-list-type';
import { ILoadDataArgs } from '@fi-shared/fi-items-list/fi-data-source-base.directive';
import { FiOnboardingService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding.service';
import { IItemsListDataFetchResult } from '@fi-shared/fi-items-list/fi-items-list';
import { FiProfileSizes } from '@fi-shared/profile-icon/profile-icon.component';
import { ILocalSearchParameter } from '@fi-shared/models/models';
import { FiOnboardingBuilderStoreService } from '@fi-app/fi-onboarding/fi-onboarding-builder/fi-onboarding-builder-store.service';

@Component({
    selector: 'fi-element-object-type-list',
    templateUrl: './element-object-type-list.component.html',
    styleUrls: ['./element-object-type-list.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
    encapsulation: ViewEncapsulation.None,
    host: { class: 'fi-element-object-type-list' },
    standalone: false,
})
export class FiElementObjectTypeListComponent extends FiRemoteStateFullDataSource<IAvailableOnboardingStepElement> {
    @Input() objectType: ObjectTypes;
    @Output() resetSelectedElementType = new EventEmitter<void>();

    protected fiOnboardingElementDropListHelperService = inject(FiOnboardingElementDropListHelperService);
    protected fiOnboardingService = inject(FiOnboardingService);
    protected fiOnboardingBuilderStoreService = inject(FiOnboardingBuilderStoreService);

    public defaultSortColumnName = '';
    public defaultSortDirection = false;
    public itemsListType = FiItemsListType.OnboardingListItems;

    protected sortDirection = false;
    protected readonly maxDisplayedItems = 8;

    protected readonly FiProfileSizes = FiProfileSizes;
    protected getObjectTypeNameTextId = getObjectTypeNameTextId;

    public loadListDataFn(
        loadArgs: ILoadDataArgs,
    ): Promise<IItemsListDataFetchResult<IAvailableOnboardingStepElement>> {
        return this.fiOnboardingService.getAvailableOnboardingElementsListDataWithCache(
            this.getParameter(loadArgs),
            loadArgs,
            this.objectType,
            this.sortDirection,
        );
    }

    private getParameter(loadArgs: ILoadDataArgs): IOnboardingElementParameter {
        const parameter = super.getItemsListParameter(loadArgs) as IOnboardingElementParameter;
        parameter.FetchParams = {
            FetchItems: true,
            FetchLightWeightObjects: true,
        };
        parameter.SelectedSort = {
            ColumnName: 'Name',
            SortDirection: this.sortDirection,
        };
        parameter.ObjectType = this.objectType;
        return parameter;
    }

    protected sortAlphabetically(): void {
        this.sortDirection = !this.sortDirection;
        this.reloadData();
    }

    onSearchChanged($event: ILocalSearchParameter) {
        this.fiOnboardingBuilderStoreService.clearElementsCache(this.objectType);
        super.onSearchChanged($event);
    }

    protected isSearchByContentAvailable(): boolean {
        return [ObjectTypes.Document, ObjectTypes.MediaBank].includes(this.objectType);
    }
}
